// extracted by mini-css-extract-plugin
module.exports = {"meta":"Meta-module--meta--1XDVh","meta__date":"Meta-module--meta__date--29eD7","meta__editLink":"Meta-module--meta__editLink--3hALI"};